import type { Weapon } from './Weapon.type'
import { WeaponTypeId } from './WeaponTypeId.enum'

const maxAmmo = 6

export default function createAttackCopterMissilesWeapon(str: number): Weapon {
  return {
    wt_id: WeaponTypeId.Missile,
    str,
    maxAmmo,
    ammo: maxAmmo,
    ammops: 1,
    ca: true,
  }
}
